import React from 'react';
// import { FadeModal } from 'boron';
import { FormGroup, FormControl, ControlLabel, Radio } from 'react-bootstrap';
import FieldGroup from './FieldGroup';
import Autocomplete from 'react-google-autocomplete';
import styled from 'styled-components';
import './modals.css';
import './modals.css';
var styles = {
  btn: {
    margin: '1em auto',
    padding: '1em 2em',
    outline: 'none',
    fontSize: 13,
    fontWeight: '600',
    background: 'black',
    color: '#FFFFFF',
    border: 'none'
  },
  container: {
    padding: '2em',
    textAlign: 'center'
  },
  title: {
    margin: 0,
    color: 'black',
    fontWeight: 400
  },
  message: {
    marginTop: '15px',
    lineHeight: '20px'
  }
};

const FadeModalContainer = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
  display: ${props => props.hidden ? 'none' : 'block'};

  background-color: white;
`;



class FadeModal extends React.Component {
  state = {
    hidden: true
  }

  show  = () => {
    this.setState({hidden: false});
  }
  
  hide = () => {
    this.setState({hidden: true});
  }
  render(){
    const { children } = this.props;
    return (
      <FadeModalContainer hidden={this.state.hidden}>
        {children}
      </FadeModalContainer>
    );
  }
}

export class MessageModal extends React.Component {
  state = {
    message: this.props.message,
    closeAction: function() {}
  };

  show(message, closeAction = function() {}) {
    this.setState(
      {
        message: message,
        closeAction: closeAction
      },
      () => this.refs.modal.show()
    );
  }
  close() {
    this.refs.modal.hide();
    this.state.closeAction();
  }
  render() {
    return (
      <FadeModal modalStyle={{ width: '100%', maxWidth: '500px' }} ref="modal">
        <div style={styles.container}>
          <h2 style={styles.title}>{this.props.title}</h2>
          <p style={styles.message}>{this.state.message}</p>
          <button style={styles.btn} onClick={this.close.bind(this)}>
            {this.props.buttonText || 'Close'}
          </button>
        </div>
      </FadeModal>
    );
  }
}

export class EditModal extends React.Component {
  state = {
    title: this.props.title,
    message: this.props.message,
    saveAction: function() {}
  };

  handleChange(e) {
    const newState = {};
    newState[e.target.name] = e.target.value;
    this.setState(newState);
  }

  show(title, message, saveAction = function() {}) {
    this.setState(
      {
        title: title,
        message: message,
        saveAction: saveAction
      },
      () => this.refs.modal.show()
    );
  }
  save() {
    this.state.saveAction(this.state.message);
    this.close();
  }

  close() {
    this.setState(
      {
        saveAction: function() {}
      },
      () => this.refs.modal.hide()
    );
  }
  render() {
    return (
      <FadeModal modalStyle={{ width: '100%', maxWidth: '500px' }} ref="modal">
        <div style={styles.container}>
          <h2 style={styles.title}>{this.state.title}</h2>
          <form style={{ marginTop: '20px' }}>
            <FormGroup controlId="formControlsTextarea">
              <FormControl
                name="message"
                componentClass="textarea"
                value={this.state.message || ''}
                onChange={this.handleChange.bind(this)}
              />
            </FormGroup>
          </form>
          <button
            style={Object.assign({}, styles.btn, { marginRight: '10px' })}
            onClick={this.save.bind(this)}
          >
            {'Save'}
          </button>
          <button style={styles.btn} onClick={this.close.bind(this)}>
            {'Close'}
          </button>
        </div>
      </FadeModal>
    );
  }
}

export class WaitlistModal extends React.Component {
  state = {
    title: 'Let Off Waitlist',
    message: 'You are about to let this user off the Waitlist',
    mcURL: null,
    mcURLValid: false,
    manualOrdering: 0,
    saveAction: function() {}
  };

  handleChange(e) {
    const newState = {};
    newState[e.target.name] = e.target.value;
    this.setState(newState);
  }

  show(mcURL, saveAction = function() {}) {
    this.setState(
      {
        mcURL: mcURL,
        manualOrdering: 0,
        mcURLValid: true,
        saveAction: saveAction
      },
      () => this.refs.modal.show()
    );
  }
  save() {
    let mcURL = null;
    if (this.state.mcURL && this.state.mcURLValid) {
      mcURL = this.state.mcURL;
    }
    this.state.saveAction(mcURL, this.state.manualOrdering);
    this.close();
  }

  close() {
    this.setState(
      {
        saveAction: function() {}
      },
      () => this.refs.modal.hide()
    );
  }

  mcURLForm() {
    if (this.state.mcURL) {
      return (
        <FormGroup
          style={{ marginTop: '20px' }}
          controlId="formControlsTextarea"
        >
          <Radio
            name="mcURL"
            value={true}
            checked={this.state.mcURLValid}
            onChange={() => this.setState({ mcURLValid: true })}
            inline
          >
            The models.com URL matches
          </Radio>
          <Radio
            name="mcURL"
            value={false}
            checked={!this.state.mcURLValid}
            onChange={() => this.setState({ mcURLValid: false })}
            inline
          >
            The models.com URL does NOT match
          </Radio>
        </FormGroup>
      );
    } else {
      return null;
    }
  }
  render() {
    return (
      <FadeModal modalStyle={{ width: '100%', maxWidth: '500px' }} ref="modal">
        <div style={styles.container}>
          <h2 style={styles.title}>{this.state.title}</h2>

          {this.mcURLForm()}
          <FieldGroup
            id="formControlsName"
            type="number"
            label="Name"
            name="name"
            label="Manual Ordering"
            style={{ margin: 'auto', marginTop: '20px', width: '100px' }}
            value={this.state.manualOrdering}
            onChange={e =>
              this.setState({ manualOrdering: parseInt(e.target.value) })
            }
          />
          <button
            style={Object.assign({}, styles.btn, { marginRight: '10px' })}
            onClick={this.save.bind(this)}
          >
            {'Save'}
          </button>
          <button style={styles.btn} onClick={this.close.bind(this)}>
            {'Close'}
          </button>
        </div>
      </FadeModal>
    );
  }
}

export class NotificationModal extends React.Component {
  state = {
    lat: null,
    lng: null,
    radius: 0,
    saveAction: function() {}
  };

  handleChange(e) {
    const newState = {};
    newState[e.target.name] = e.target.value;
    this.setState(newState);
  }

  show(saveAction = function() {}) {
    this.setState(
      {
        lat: null,
        lng: null,
        radius: 0,
        saveAction: saveAction
      },
      () => this.refs.modal.show()
    );
  }

  save() {
    this.state.saveAction(this.state.lat, this.state.lng, this.state.radius);
    this.close();
  }

  close() {
    this.setState(
      {
        lat: null,
        lng: null,
        radius: 0,
        saveAction: function() {}
      },
      () => this.refs.modal.hide()
    );
  }

  showSaveButton() {
    if (this.state.lat && this.state.lng && this.state.radius) {
      return (
        <button
          style={Object.assign({}, styles.btn, { marginRight: '10px' })}
          onClick={this.save.bind(this)}
        >
          {'Save'}
        </button>
      );
    }
  }

  render() {
    const self = this;
    return (
      <FadeModal modalStyle={{ width: '100%', maxWidth: '500px' }} ref="modal">
        <div style={styles.container}>
          <h2 style={styles.title}>Notify Potential Applicants</h2>
          <Autocomplete
            style={{ width: '90%', marginTop: '20px' }}
            onPlaceSelected={place => {
              self.setState({
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
              });
            }}
            types={['(cities)']}
          />
          <FieldGroup
            id="formControlsName"
            type="number"
            name="radius"
            label="Radius (kilometers)"
            placeholder="Radius"
            style={{ margin: 'auto', marginTop: '20px', width: '130px' }}
            value={this.state.radius}
            onChange={e => this.setState({ radius: parseInt(e.target.value) })}
          />
          {this.showSaveButton()}
          <button style={styles.btn} onClick={this.close.bind(this)}>
            {'Close'}
          </button>
        </div>
      </FadeModal>
    );
  }
}


export class ApproveJobModal extends React.Component {
  state = {
    number: 0,
    editorial_tier: 0,
    commercial_tier: 0,
    saveAction: function() {}
  };

  handleChange(e) {
    const newState = {};
    newState[e.target.name] = e.target.value;
    this.setState(newState);
  }

  show(
    manual_ordering = 0,
    editorial_tier = 0,
    commercial_tier = 0,
    saveAction = function() {}
  ) {
    this.setState(
      {
        title: 'Approve Job',
        okText: 'Confirm',
        manual_ordering: manual_ordering,
        editorial_tier: editorial_tier,
        commercial_tier: commercial_tier,
        saveAction: saveAction
      },
      () => this.refs.modal.show()
    );
  }

  save() {
    this.state.saveAction(
      this.state.manual_ordering,
      this.state.editorial_tier,
      this.state.commercial_tier
    );
    this.close();
  }

  close() {
    this.setState(
      {
        manual_ordering: 0,
        editorial_tier: 0,
        commercial_tier: 0,
        saveAction: function() {}
      },
      () => this.refs.modal.hide()
    );
  }

  showSaveButton() {
    return (
      <button
        style={Object.assign({}, styles.btn, { marginRight: '10px' })}
        onClick={this.save.bind(this)}
      >
        {this.state.okText}
      </button>
    );
  }

  render() {
    const self = this;
    return (
      <FadeModal modalStyle={{ width: '100%', maxWidth: '500px' }} ref="modal">
        <div style={styles.container}>
          <h2 style={styles.title}>{this.state.title}</h2>
          <FieldGroup
            id="formControlsName"
            type="number"
            name="manual_ordering"
            label="Manual Ordering"
            placeholder="Manual Ordering"
            style={{ margin: 'auto', marginTop: '20px', width: '130px' }}
            value={this.state.manual_ordering}
            onChange={e =>
              this.setState({ manual_ordering: parseInt(e.target.value) })
            }
          />
          <FieldGroup
            id="formControlsName"
            type="number"
            name="editorial_tier"
            label="Editorial Tier"
            min="0"
            max="5"
            placeholder="Editorial Tier"
            style={{ margin: 'auto', marginTop: '20px', width: '130px' }}
            value={this.state.editorial_tier}
            onChange={e =>
              this.setState({ editorial_tier: parseInt(e.target.value) })
            }
          />
          <FieldGroup
            id="formControlsName"
            type="number"
            name="commercial_tier"
            label="Commercial Tier"
            min="0"
            max="5"
            placeholder="Commercial Tier"
            style={{ margin: 'auto', marginTop: '20px', width: '130px' }}
            value={this.state.commercial_tier}
            onChange={e =>
              this.setState({ commercial_tier: parseInt(e.target.value) })
            }
          />
          {this.showSaveButton()}
          <button style={styles.btn} onClick={this.close.bind(this)}>
            {'Close'}
          </button>
        </div>
      </FadeModal>
    );
  }
}

export class CancelJobModal extends React.Component {
  state = {
    title: 'Cancel Job',
    saveAction: function() {}
  };

  handleChange(e) {
    const newState = {};
    newState[e.target.name] = e.target.value;
    this.setState(newState);
  }

  show(
    title,
    saveAction = function() {}
  ) {
    this.setState(
      {
        title: title,
        okText: 'Confirm',
        saveAction: saveAction
      },
      () => this.refs.modal.show()
    );
  }

  save() {
    this.state.saveAction();
    this.close();
  }

  close() {
    this.setState(
      {
        saveAction: function() {}
      },
      () => this.refs.modal.hide()
    );
  }

  showSaveButton() {
    return (
      <button
        style={Object.assign({}, styles.btn, { marginRight: '10px' })}
        onClick={this.save.bind(this)}
      >
        {this.state.okText}
      </button>
    );
  }

  render() {
    const self = this;
    return (
      <FadeModal modalStyle={{ width: '100%', maxWidth: '500px' }} ref="modal">
        <div style={styles.container}>
          <h2 style={styles.title}>{this.state.title}</h2>
          {this.showSaveButton()}
          <button style={styles.btn} onClick={this.close.bind(this)}>
            {'Close'}
          </button>
        </div>
      </FadeModal>
    );
  }
}

export class CreateUniversalCodeModal extends React.Component {
  state = {
    maxRedeems: 0,
    code: null
  };

  show() {
    this.refs.modal.show();
  }

  save() {
    this.props.saveAction(this.state.maxRedeems).then(response => {
      this.setState({ code: response.code });
    });
    // this.close();
  }

  close() {
    // this.setState({ code: null });
    this.refs.modal.hide();
  }

  render() {
    const self = this;
    return (
      <FadeModal modalStyle={{ width: '100%', maxWidth: '500px' }} ref="modal">
        <div style={styles.container}>
          <h2 style={styles.title}>Create Universal Ref Code</h2>
          <FieldGroup
            type="number"
            name="maxRedeems"
            label="Max Redeems"
            style={{ margin: 'auto', marginTop: '20px', width: '130px' }}
            value={this.state.maxRedeems}
            onChange={e =>
              this.setState({ maxRedeems: parseInt(e.target.value) })
            }
          />
          {this.state.code && (<div style={{marginTop: '5px'}}>
            <b>Code:</b> {this.state.code.code}, <b>Max Redeems:</b> {this.state.code.max_redeems}
          </div>)}
          <button
            style={Object.assign({}, styles.btn, { marginRight: '10px' })}
            onClick={this.save.bind(this)}
          >
            {'Confirm'}
          </button>
          <button style={styles.btn} onClick={this.close.bind(this)}>
            {'Close'}
          </button>
        </div>
      </FadeModal>
    );
  }
}

export class RefundAmountModal extends React.Component {
  state = {
    amount: 0.5,
    hire: null
  };

  show(hire) {
    this.setState({ hire });
    this.refs.modal.show();
  }

  save() {
    if (window.prompt(
      `Type "confirm" if you are sure you want to refund ${this.state.amount * 100}%`
    ) === 'confirm') {
      this.props.saveAction(this.state.hire, parseFloat(this.state.amount), 10);
    }
  }

  close() {
    this.refs.modal.hide();
  }

  render() {
    return (
      <FadeModal modalStyle={{ width: '100%', maxWidth: '500px' }} ref="modal">
        <div style={styles.container}>
          <h2 style={styles.title}>Please Select an option</h2>
          <div style={styles.container}>
            <select onChange={event => {
              this.setState({ amount: event.target.value })
            }}>
                <option selected value="0.5">50%</option>
                <option value="1">100%</option>
            </select>
          </div>
          <button
            style={Object.assign({}, styles.btn, { marginRight: '10px' })}
            onClick={this.save.bind(this)}
          >
            {'Confirm'}
          </button>
          <button style={styles.btn} onClick={this.close.bind(this)}>
            {'Close'}
          </button>
        </div>
      </FadeModal>
    );
  }
}

export class EditNumberModal extends React.Component {
  state = {
    number: 0,
    saveAction: function() {}
  };

  handleChange(e) {
    const newState = {};
    newState[e.target.name] = e.target.value;
    this.setState(newState);
  }

  show(title, subtitle, okText, number = 0, saveAction = function() {}) {
    this.setState(
      {
        title: title,
        subtitle: subtitle,
        okText: okText,
        number: number,
        saveAction: saveAction
      },
      () => this.refs.modal.show()
    );
  }

  save() {
    this.state.saveAction(this.state.number);
    this.close();
  }

  close() {
    this.setState(
      {
        number: 0,
        saveAction: function() {}
      },
      () => this.refs.modal.hide()
    );
  }

  showSaveButton() {
    return (
      <button
        style={Object.assign({}, styles.btn, { marginRight: '10px' })}
        onClick={this.save.bind(this)}
      >
        {this.state.okText}
      </button>
    );
  }

  render() {
    const self = this;
    return (
      <FadeModal modalStyle={{ width: '100%', maxWidth: '500px' }} ref="modal">
        <div style={styles.container}>
          <h2 style={styles.title}>{this.state.title}</h2>
          <FieldGroup
            id="formControlsName"
            type="number"
            name="number"
            label={this.state.subtitle}
            placeholder="Radius"
            style={{ margin: 'auto', marginTop: '20px', width: '130px' }}
            value={this.state.number}
            onChange={e => this.setState({ number: parseInt(e.target.value) })}
          />
          {this.showSaveButton()}
          <button style={styles.btn} onClick={this.close.bind(this)}>
            {'Close'}
          </button>
        </div>
      </FadeModal>
    );
  }
}
